import { ExportTerminovApi } from 'tezaury-frontend-ts-axios';
import { ClientResponse } from '../../model/ClientResponse';
import apiConfiguration from '../configuration/apiConfiguration';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';
import getFileName from '../../functions/getFileName';
import PouzitiePredpis from '../../model/PouzitiePredpis';

const client = new ExportTerminovApi(apiConfiguration(tezauryPrefixPath));

interface DocumentResponse {
  fileName: string;
  blob: Blob;
}

export const exportTerminList = async (
  tezaurusUuid?: Uuid,
  hladanyTermin?: string,
  legalnyZdroj?: string,
  doktrinalnyZdroj?: string,
  pouzitiePredpisList?: Array<PouzitiePredpis>,
  options?: { headers?: never },
): Promise<ClientResponse<DocumentResponse>> => {
  const {
    data,
    headers,
    status,
  } = await client.getExportOfTerminList(
    tezaurusUuid,
    encodeURIComponent(hladanyTermin),
    encodeURIComponent(legalnyZdroj),
    encodeURIComponent(doktrinalnyZdroj),
    pouzitiePredpisList.map(predpis => encodeURIComponent(predpis.popis)),
    {
      ...options,
      responseType: 'blob',
    },
  );

  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};

export const exportTerminListAdmin = async (
  tezaurusUuid?: Uuid,
  hladanyTermin?: string,
  publikovany?: boolean,
  autorPoslednejZmeny?: Uuid,
  options?: { headers?: never },
): Promise<ClientResponse<DocumentResponse>> => {
  const {
    data,
    headers,
    status,
  } = await client.getExportOfTerminListAdmin(
    tezaurusUuid,
    hladanyTermin,
    publikovany,
    autorPoslednejZmeny,
    {
      ...options,
      responseType: 'blob',
    },
  );

  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
